<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiHospitalBuilding }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Out-Patient Request Procedure
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- END APP BAR -->

        <v-container>
            <div class="procedure">
                <h2>Step 1</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step01.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 2</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step02.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 3</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step03.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 4</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step04a.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step04b.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 5</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05a.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05b.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05b2.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05b3.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05b4.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step05b5.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 6</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step06.webp" alt="">
                </div>
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step062.webp" alt="">
                </div>
            </div>
            <div class="procedure">
                <h2>Step 7</h2>
                <v-divider />
                <div class="proc-img">
                    <img src="../../../assets/out-patient-req-steps/Step07.webp" alt="">
                </div>
            </div>
        </v-container>
    </section>
</template>

  <script>
import { mdiHospitalBuilding } from '@mdi/js'

export default {
    data: () => ({
        mdiHospitalBuilding
    })
}
  </script>

  <style scoped>
  section {
    background-image: url("../../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
  }

  .procedure {
    width: 80%;
    margin: auto;
  }
  .procedure h2 {
    color: #1b5e20;
    font-size: 1.8em;
  }

  .proc-img {
    width: 60%;
    padding: 2em 0;
    margin: auto;
  }

  .nav h2 {
      font-size: 25px;
  }
  .proc-img img {
    width: 100%;
  }

  /* @media (max-width: 960px) {
    .procedure {
      width: 90%;
    }
    .proc-img {
      width: 100%;
    }
  } */
  @media (max-width: 390px) {
    .page-icon {
      display: none;
    }
  }
  @media (max-width: 1260px) {
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      padding-top: 10px;
      font-size: 30px;
    }
    .procedure {
      width: 90%;
    }
    .proc-img {
      width: 100%;
    }
  }
  </style>
